@file:OptIn(ExperimentalWasmJsInterop::class, ExperimentalSerializationApi::class)

package org.matthewo

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.compression.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.resources.*
import io.ktor.serialization.kotlinx.cbor.*
import js.promise.catch
import js.reflect.Reflect
import kotlinx.serialization.ExperimentalSerializationApi
import react.create
import react.dom.client.createRoot
import web.dom.ElementId
import web.dom.document
import web.events.EventHandler
import web.html.HtmlTagName.div
import web.navigator.navigator
import web.window.window

val client = HttpClient(Js) {
    install(ContentEncoding) {
        deflate(1.0F)
        gzip(0.9F)
    }
    install(ContentNegotiation) {
        cbor()
    }
    install(Resources)
}

suspend fun main() {
    if (Reflect.has(navigator, "serviceWorker")) {
        window.onload = EventHandler {
            navigator.serviceWorker.registerAsync("/sw.min.js")
                .then { println("Service worker registered with scope: ${it.scope}") }
                .catch { console.warn("Service worker registration failed: $it") }
        }
    }
    reloadAfterAway()
    val app = document.createElement(div).apply {
        id = ElementId("app")
    }
    document.body.appendChild(app)
    createRoot(app).render(Router.create())
}
